import { cn } from '../../lib/utils';

interface LogoProps {
  src?: string | null;
  alt?: string;
  className?: string;
}

export function Logo({ src, alt = 'Logo', className }: LogoProps) {
  if (!src) {
    return null;
  }

  return (
    <img
      src={src}
      alt={alt}
      className={cn('h-10 object-contain', className)}
    />
  );
}
